const ENV = process.env.VUE_APP_ENV

export const APPID = 80001
// channelid和activitycode 基于 http://wiki.vipkid.com.cn/pages/viewpage.action?pageId=170008347
export const ACTIVITYCODE = ENV === 'production' ? '3129dc309587ed47' : '1873a332591b6ff2'
export const CHANNELID = ENV === 'production' ? '14768063' : '14767147'

export default {
  env: ENV,
  appid: APPID,
  activityCode: ACTIVITYCODE,
  channelId: CHANNELID
}
